/**
 * Shared tiered promotions sticky bar (vault + standalone collection templates).
 */

function updateGorgiasChatPosition() {
  const gorgaisWidget = document.querySelector('iframe#chat-button');
  if (!gorgaisWidget) return;

  if (window.innerWidth < 1080) {
    const promoHeight = document.querySelector('.sticky-promotion-section:not(.open)')?.offsetHeight;
    gorgaisWidget.style.bottom = promoHeight ? `${promoHeight}px` : '20px';
  } else {
    gorgaisWidget.style.bottom = '20px';
  }
}

function initStickyPromotionClicks() {
  const stickyPromoSection = document.querySelector('.sticky-promotion-section');
  if (!stickyPromoSection || stickyPromoSection.dataset.promoClicksBound === 'true') return;

  stickyPromoSection.dataset.promoClicksBound = 'true';
  stickyPromoSection.addEventListener('click', (e) => {
    if (e.target.classList.contains('checkout')) return;
    if (e.target.classList.contains('promotion-add-to-cart-btn')) return;

    const widget = stickyPromoSection.querySelector('.promotional-widget');
    if (!widget) return;

    if (stickyPromoSection.classList.contains('open')) {
      if (widget.classList.contains('initial')) {
        window.scrollTo(0, 0);
        widget.classList.remove('initial');
      }
      stickyPromoSection.classList.remove('open');
      widget.classList.remove('open');

      const giftDetails = widget.querySelector('.gift-section--details');
      if (giftDetails) giftDetails.classList.add('hidden');

      document.querySelectorAll('.vault-promotions__init-content').forEach((elem) => {
        elem.classList.add('hidden');
      });
    } else {
      stickyPromoSection.classList.add('open');
      widget.classList.add('open');

      const giftDetails = widget.querySelector('.gift-section--details');
      if (giftDetails) giftDetails.classList.remove('hidden');
    }

    updateGorgiasChatPosition();
  });
}

function initStandaloneTieredPromotions() {
  const section = document.querySelector('.sticky-promotion-section.promotions--standalone');
  if (!section) return;

  section.classList.remove('hidden');
  initStickyPromotionClicks();
  updateGorgiasChatPosition();
}

window.initStickyPromotionClicks = initStickyPromotionClicks;
window.initStandaloneTieredPromotions = initStandaloneTieredPromotions;
window.updateGorgiasChatPosition = updateGorgiasChatPosition;

document.addEventListener('DOMContentLoaded', () => {
  initStandaloneTieredPromotions();
  const stickyPromo = document.querySelector('.sticky-promotion-section:not(.promotions--standalone)');
  if (stickyPromo) initStickyPromotionClicks();
});
